// extracted by mini-css-extract-plugin
module.exports = {"FlashingBlock":"FlashingBlock_FlashingBlock__4omyC","text-flash":"FlashingBlock_text-flash__w2Z0t"};